import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Section = styled.section`
  position: relative;

  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  @media (max-width: 1279px) {
    background-size: 269px 100px;
  }
`;

export const BackgroundOverlay = styled(UI.BackgroundOverlay)`
  /* z-index: -1; */
`;

export const Title = styled.h2`
  margin: 0;
  margin-right: ${UI.mobileSideOffset};
  margin-left: ${UI.mobileSideOffset};
  padding-top: 1.7em;
  padding-bottom: 1.7em;
  position: relative;
  z-index: 2;

  @media (min-width: 1280px) {
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    width: 62.5%;
    /* margin-left: 7.5%; */
    margin-left: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginLeft};
    margin-right: ${({ textHorizAlign }) =>
    UI.marginAlignMap[textHorizAlign] &&
      UI.marginAlignMap[textHorizAlign].marginRight};
  }
`;



// WEBPACK FOOTER //
// ./src/components/modules/NoteSection/styled.js